import { createContentPropTypes } from '../../../helpers/content';

const content = {
	AuthorisationHeader: 'Authorisation required',
	AuthorisationMayHeader: 'Authorisation may be required',
	AuthorisationBodyMsg:
		'Once you’ve confirmed the details are correct and you choose to continue, any transactions that are highlighted will have to be authorised using one of our online security methods.',
	AuthorisationByUserSubTitle: 'This will need authorised by ',
	AuthorisationMayByUserSubTitle: 'This may need authorised by',
	AuthorisationTitle: 'Authorisation required',
	AuthorisationSubTitle: 'This will need authorised once you continue.',
	PaymentAuthorisation: 'This will need authorised once you continue',
	PaymentAuthorisationByNamed: 'This will need authorised by',
	PageHeader: 'Review',
	PageSubHeader: 'Please confirm the details you’ve entered are correct before you continue.',
	BatchAuthorisationBodyMsg: 'This will need authorised by ',
	fromLabel: 'From',
	toLabel: 'To',
	amtLabel: 'Amount',
	refLabel: 'Reference',
	dateLabel: 'Date',
	typeLabel: 'Type',
	continueButtonText: 'Confirm and submit',
	cancel: 'Cancel',
	continue: 'Continue',
	authoriserModalHeader: 'Select user to authorise payment',
	authoriserModalDescription: 'Please choose which user you want to authorise your payment.',
	changeAuthoriserButton: 'Change',
	selectAuthoriserButton: 'Select user to authorise',
	viewAuthoriserButton: 'View users who can authorise',
	authoriserValidationMessage:
		'Please select which user will provide authorisation before you confirm and submit your payment.',
};

const traObligateContent = {
	...content,
	AuthorisationHeader: 'Authorisation may be required',
	AuthorisationBodyMsg:
		'Once you’ve confirmed the details are correct and you choose to continue, any transactions that are highlighted may have to be authorised using one of our online security methods.',
	AuthorisationByUserSubTitle: 'This may need authorised by',
};

export const contentPropTypes = createContentPropTypes(content);

export default { content, traObligateContent };
